import { PlainButton } from '../../../shared/Button'

import styles from './batchView.module.scss'

export function BatchView ({ onClick }) {
  return (
    <div className={styles.batchView}>
      <PlainButton
        color='light-primary'
        btnType='contained'
        label='Assign to me'
        style={{
          padding: '10px 35px',
          backgroundColor: 'rgb(204, 239, 248)',
          color: 'rgb(14, 180, 221)'
        }}
        onClick={() => onClick('assign')}
      />
      <PlainButton
        color='light-primary'
        btnType='contained'
        label='Complete'
        style={{
          padding: '10px 35px',
          backgroundColor: '#ECF5D9',
          color: '#81B800'
        }}
        onClick={() => onClick('completed')}
      />
      <PlainButton
        color='light-primary'
        label='Cancel'
        btnType='contained'
        style={{
          padding: '10px 35px',
          backgroundColor: '#FFDBDC',
          color: '#FA0D16'
        }}
        onClick={() => onClick('cancelled')}
      />
      <PlainButton
        color='default'
        label='Discard'
        btnType='contained'
        style={{
          padding: '10px 35px',
          backgroundColor: '#F9F9F9'
        }}
        onClick={() => onClick('discard')}
      />
    </div>
  )
}
